import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getLandingPageContentAPI,
  getRootKeyApi,
} from "../../../Store/Action/homePageAction";
import Footer from "../Layout/Footer/Footer";
import Header from "../Layout/Header/Header";
import Banner from "./Banner";
import BrandImages from "./BrandImages";
import ShopByCategory from "./CategorySection";
import HighlightProductCollection from "./HighlightProductCollection";
import HighlightProductCollection2 from "./HighlightProductCollection2";
import LatestBrandCollection from "./LatestBrandCollection";
import ShopByColor from "./ShopByColor";
import StaticServicesInfo from "./StaticServicesInfo";
import TopSellingProducts from "./TopSellingProducts";
import NewArrival from "./NewArrival";
import {
  getCartAPI,
  getCartBrandsAPI,
  getCartTotalAPI,
} from "../../../Store/Action/cartAction";
import {
  getLoggedInUserDetailsAPI,
  getUserDetailsAPI,
} from "../../../Store/Action/UserAction";
import OrderWeightInfoPopup from "../Auth/MyAccount/CustomModals/OrderWeightInfoPopup";
import { getLiveRateAPI } from "../../../Store/Action/globalAction";
// 🆕 Add MUI Dialog for popup
import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Icons from "../../../Config/Images";
import { red } from "@mui/material/colors";
import { Helmet } from "react-helmet-async";
import ShopByMetalCategory from "./ShopByMetalCategory/ShopByMetalCategory";

const LandingPage = () => {
  const [loading, setLoading] = useState(false);
  const [landingPageData, setLandingPageData] = useState([]);
  const [showAdPopup, setShowAdPopup] = useState(false); // 🆕 For first-time ad popup
  const [currentUserId, setCurrentUserId] = useState(null);
  const [userRole, setUserRole] = useState("");
  const cartChangeTrigger = useSelector(
    (state) => state.popupTrigger.cartChangeTrigger,
  );

  const dispatch = useDispatch();

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [cartBrands, setCartBrands] = useState([]);

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const user = useSelector((state) => state.auth.user);

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };
  // useEffect(() => {
  //   dispatch(
  //     getUserDetailsAPI({ userId: 78 }, (res) => {
  //       console.log("checking res");
  //       console.log(res);
  //     }),
  //   );
  // }, []);
  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        const role = result?.data?.[0]?.user_role_name;
        setUserRole(role);

        const loggedInUserId = result?.data?.[0]?.user_id;

        if (loggedInUserId) {
          setCurrentUserId(loggedInUserId);
        } else if (user) {
          setCurrentUserId(Number(user?.user_details?.user_id));
        }

        // const userDetails = result?.data?.[0];
        // if (
        //   userDetails?.global_cart_info?.find((e) => e?.product)?.product
        //     ?.length > 0 ||
        //   userDetails?.isPerPcsProduct
        // ) {
        //   setIsPopupVisible(true);
        // } else {
        //   setIsPopupVisible(true);
        // }
      }),
    );
  }, [cartChangeTrigger, dispatch]);
  useEffect(() => {
    dispatch(
      getCartTotalAPI({}, (result) => {
        if (result?.status && result?.data?.length > 0) {
          const cart = result.data[0];
          const hasItems =
            Object.values(cart.product_total).some(
              (item) => item.quantity > 0,
            ) ||
            Object.values(cart.per_pc_product_total).some(
              (item) => item.quantity > 0,
            );

          setIsPopupVisible(hasItems);
        }
      }),
    );
  }, [dispatch, cartChangeTrigger]);

  useEffect(() => {
    dispatch(
      getCartBrandsAPI({}, (res) => {
        if (res?.status && res?.data?.length > 0) {
          setCartBrands(res.data);
          setIsPopupVisible(true);
        } else {
          setCartBrands([]);
          setIsPopupVisible(false);
        }
      }),
    );
  }, [dispatch, cartChangeTrigger]);

  /** 📌 Safety fallback if API didn’t return but Redux has userId */
  useEffect(() => {
    if (!currentUserId && user?.user_details?.user_id) {
      setCurrentUserId(Number(user.user_details.user_id));
    }
  }, [user, currentUserId]);

  // 🆕 Check if user is first-time visitor
  useEffect(() => {
    const hasSeenAd = localStorage.getItem("hasSeenAdPopup");
    if (!hasSeenAd) {
      setShowAdPopup(true);
      localStorage.setItem("hasSeenAdPopup", "true");
    }
  }, []);

  useEffect(() => {
    // setLoading(true);
    if (!currentUserId) return;
    const params = {
      user_id: currentUserId,
      flag_web: true,
      root_key: 2,
    };
    dispatch(
      getLandingPageContentAPI(params, (result) => {
        setLandingPageData(result);
        setLoading(false);
      }),
    );
  }, [dispatch, currentUserId]);
  // const refreshCartLength = () => {
  //   dispatch(getCartAPI({}, (result) => {}));
  // };
  const onFetchGetWishlist = useCallback(() => {
    if (!currentUserId) return;
    const params = {
      user_id: currentUserId,
      flag_web: true,
    };
    dispatch(
      getLandingPageContentAPI(params, (result) => {
        setLandingPageData(result);
        // refreshCartLength();
      }),
    );
  }, [dispatch, currentUserId]);

  // Check if landingPageData is loaded and contains the data before accessing it
  const shopByCategoryData =
    landingPageData && landingPageData?.[0]?.shop_by_category;
  const productMetal = landingPageData && landingPageData?.[0]?.shop_by_metal;
  const nosePinCollection =
    landingPageData && landingPageData?.[0]?.nosepin_category;
  const ringCollection = landingPageData && landingPageData?.[0]?.ring_category;
  const topSellingProducts =
    landingPageData && landingPageData?.[0]?.top_selling_product;
  const newArrivalData = landingPageData && landingPageData?.[0]?.new_arrival;
  const bannerImagesData =
    landingPageData && landingPageData?.[0]?.banner_image;
  const brandImagesData = landingPageData && landingPageData?.[0]?.latest_brand;
  const latestBrandCollectionData =
    landingPageData && landingPageData?.[0]?.latest_brand;
  const shopByGoldData = landingPageData && landingPageData?.[0]?.shop_by_gold;
  const shopBySilverData =
    landingPageData && landingPageData?.[0]?.shop_by_silver;
  return (
    <>
      <Helmet>
        <title>Zabali - Explore Top Brands & Products</title>

        <meta
          name="description"
          content="Shop from a wide range of products, explore collections, and enjoy exclusive deals on Zabali."
        />

        <meta
          property="og:title"
          content="Zabali - Explore Top Brands & Products"
        />
        <meta
          property="og:description"
          content="Shop from a wide range of products on Zabali."
        />

        <meta
          property="og:image"
          content="https://www.zabali.co/images/zabali-preview-2.jpg"
        />

        <meta property="og:url" content="https://www.zabali.co/" />

        <link rel="canonical" href="https://www.zabali.co/" />
      </Helmet>
      <Header />
      <BrandImages data={brandImagesData} />
      <Banner data={bannerImagesData} />
      {/* shop by gold */}
      <ShopByMetalCategory
        data={shopByGoldData}
        title="Shop by Gold"
        subtitle="Explore our gold collection, crafted to perfection"
        // viewAllPath="/shop-by-gold"
        metalName="Gold"
      />

      <NewArrival
        data={newArrivalData}
        onFetchGetWishlist={onFetchGetWishlist}
        userRole={userRole}
      />

      {/* shop by sliver */}
      <ShopByMetalCategory
        data={shopBySilverData}
        title="Shop by Silver"
        subtitle="Explore our silver collection, crafted to perfection"
        // viewAllPath="/shop-by-silver"
        metalName="Silver"
      />

      <TopSellingProducts
        data={topSellingProducts}
        onFetchGetWishlist={onFetchGetWishlist}
        userRole={userRole}
      />
      {/* <StaticServicesInfo /> */}
      <LatestBrandCollection data={latestBrandCollectionData} />

      {/* Nosepin collection */}
      <HighlightProductCollection data={nosePinCollection} />

      {/* Ring collection */}
      <HighlightProductCollection2 data={ringCollection} />

      <ShopByColor data={productMetal} />
      <Footer />
      {/* 🆕 Advertisement Popup */}
      <Dialog
        open={showAdPopup}
        onClose={(event, reason) => {
          // Prevent closing on backdrop click or ESC key
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          setShowAdPopup(false);
        }}
        sx={{
          zIndex: 10000, // higher than navbar (9999)
        }}
        disableEscapeKeyDown
        maxWidth="sm"
        BackdropProps={{
          style: { backgroundColor: "rgba(0,0,0,0.6)" },
        }}
        PaperProps={{
          style: {
            borderRadius: "16px",
            overflow: "hidden",
            position: "relative",
            background: "transparent",
            boxShadow: "none",
          },
        }}
      >
        <div
          style={{
            position: "relative",
            display: "inline-block",
            margin: "auto",
          }}
        >
          {/* ✅ Custom Cross Icon — better aligned & styled */}
          <img
            onClick={() => setShowAdPopup(false)}
            src={Icons.cross_icon}
            alt="Close"
            style={{
              position: "absolute",
              top: "8px",
              right: "8px",
              height: "30px",
              width: "30px",
              background: "white",
              borderRadius: "50%",
              padding: "0px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.25)",
              cursor: "pointer",
              zIndex: 10,
              transition: "transform 0.2s ease",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.transform = "scale(1.10)")
            }
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />

          {/* ✅ Ad Image */}
          <img
            src={Icons.free_world_tour_home_img}
            alt="Advertisement"
            style={{
              width: "80vw",
              maxWidth: "500px",
              height: "auto",
              borderRadius: "16px",
              display: "block",
              boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            }}
          />
        </div>
      </Dialog>
      {isPopupVisible && (
        <OrderWeightInfoPopup
          onClose={handleClosePopup}
          // refreshTrigger={cartChangeTrigger}
          cartBrands={cartBrands}
        />
      )}
    </>
  );
};

export default LandingPage;
